
import { Home, Car, Search, Shield, FileText, Receipt, Mail, Settings, LogOut } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { useToast } from "@/hooks/use-toast";
import NotificationBell from "./notifications/NotificationBell";

const menuItems = [
  {
    title: "Home",
    url: "/",
    icon: Home,
  },
  {
    title: "Find Parking",
    url: "/search",
    icon: Search,
  },
  {
    title: "List Your Spot",
    url: "/list-spot",
    icon: Car,
  },
  {
    title: "My Listings",
    url: "/my-listings",
    icon: Settings,
  },
  {
    title: "Privacy Policy",
    url: "/privacy-policy",
    icon: Shield,
  },
  {
    title: "Terms & Conditions",
    url: "/terms",
    icon: FileText,
  },
  {
    title: "Refund Policy",
    url: "/refund-policy",
    icon: Receipt,
  },
  {
    title: "Contact",
    url: "/contact",
    icon: Mail,
  },
];

export function AppSidebar() {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSignOut = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      navigate('/login');
      toast({
        title: "Signed out successfully",
        description: "You have been signed out of your account.",
      });
    } catch (error) {
      console.error('Error signing out:', error);
      toast({
        title: "Error",
        description: "Failed to sign out. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <Sidebar className="bg-primary text-white !bg-opacity-100">
      <SidebarContent className="bg-primary">
        <SidebarGroup>
          <div className="flex items-center justify-between px-4 py-2 bg-primary">
            <SidebarGroupLabel className="text-white/70">Navigation</SidebarGroupLabel>
            <NotificationBell />
          </div>
          <SidebarGroupContent className="bg-primary">
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild tooltip={item.title}>
                    <Link to={item.url} className="flex items-center text-white hover:bg-primary-700">
                      <item.icon className="h-4 w-4 mr-2" />
                      <span>{item.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
              <SidebarMenuItem>
                <SidebarMenuButton
                  onClick={handleSignOut}
                  className="flex items-center text-white hover:bg-primary-700 w-full"
                  tooltip="Sign Out"
                >
                  <LogOut className="h-4 w-4 mr-2" />
                  <span>Sign Out</span>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
